import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../../../shared/services/api.service';
import { ColDef } from 'ag-grid-community';

export interface Device {
  os: string;
  brand: string;
  name: string;
}

export interface CompatibleDevicesResponse {
  error: boolean;
  data: {
    data: Device[];
  };
  message: string;
}

@Component({
  standalone: false,
  selector: 'app-sim-compatible-devices',
  templateUrl: './sim-compatible-devices.component.html',
  styleUrl: './sim-compatible-devices.component.scss'
})
export class SimCompatibleDevicesComponent implements OnInit {
  devices: Device[] = [];
  loading = true;
  error: string | null = null;
  gridApi: any;
  gridColumnApi: any;

  constructor(
    private router: Router,
    private apiService: ApiService
  ) {}

  columnDefs: ColDef[] = [
    {
      headerName: 'OS',
      field: 'os',
      editable: false,
      filter: true,
      sortable: true,
      width: 150,
      valueFormatter: (params) => params.value ? params.value.charAt(0).toUpperCase() + params.value.slice(1) : ''
    },
    {
      headerName: 'Brand',
      field: 'brand',
      editable: false,
      filter: true,
      sortable: true,
      width: 200
    },
    {
      headerName: 'Device Name',
      field: 'name',
      editable: false,
      filter: true,
      sortable: true,
      flex: 1
    }
  ];

  gridOptions: any = {
    columnDefs: this.columnDefs,
    rowData: this.devices,
    rowSelection: 'single',
    pagination: true,
    paginationPageSize: 15,
    domLayout: 'normal',
    defaultColDef: {
      resizable: true,
      filter: true,
      sortable: true
    },
    onGridReady: (params: any) => {
      params.api.sizeColumnsToFit();
      window.addEventListener('resize', function() {
        setTimeout(function() {
          params.api.sizeColumnsToFit();
        });
      });
    }
  };

  ngOnInit(): void {
    this.loadCompatibleDevices();
  }

  loadCompatibleDevices(): void {
    // The JWT interceptor will automatically add the token header
    this.apiService.getData('/api/airalo/compatible-devices-lite').subscribe({
      next: (response: CompatibleDevicesResponse) => {
        if (!response.error && response.data && response.data.data) {
          this.devices = response.data.data;
          if (this.gridApi) {
            this.gridApi.setRowData(this.devices);
          } else {
            this.gridOptions.rowData = this.devices;
          }
        } else {
          this.error = 'Failed to load compatible devices';
        }
        this.loading = false;
      },
      error: (err) => {
        console.error('Error fetching compatible devices:', err);
        this.error = 'Error loading compatible devices';
        this.loading = false;
      }
    });
  }

  onGridReady(params: any): void {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    
    params.api.sizeColumnsToFit();
    window.addEventListener('resize', function() {
      setTimeout(function() {
        params.api.sizeColumnsToFit();
      });
    });
  }

  goBack(): void {
    this.router.navigate(['/app/sims']);
  }
}